import { render } from "./PushCreateMessage.vue?vue&type=template&id=c941c7fe&scoped=true"
import script from "./PushCreateMessage.vue?vue&type=script&lang=js"
export * from "./PushCreateMessage.vue?vue&type=script&lang=js"

import "./PushCreateMessage.vue?vue&type=style&index=0&id=c941c7fe&lang=scss&scoped=true"
import "./PushCreateMessage.vue?vue&type=style&index=1&id=c941c7fe&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c941c7fe"]])

export default __exports__